"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var common_1 = require("./common");
var CLASSES = require('./resources/classes.json');
var LINK_TYPES = require('./resources/linkTypes.json');
var ELEMENTS = require('./resources/elements.json');
var LINKS = require('./resources/links.json');
var CLASS_NAME = 'ontodia-toolbar';
var Toolbar = /** @class */ (function (_super) {
    tslib_1.__extends(Toolbar, _super);
    function Toolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toolbar.prototype.render = function () {
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: 'ontodia-btn-group ontodia-btn-group-sm' },
                React.createElement("span", { className: CLASS_NAME + "__layout-group" },
                    React.createElement("label", { className: 'ontodia-label' },
                        React.createElement("span", null, "Layout - ")),
                    React.createElement("span", { className: 'ontodia-btn-group ontodia-btn-group-sm' },
                        React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', onClick: this.props.onForceLayout },
                            React.createElement("span", { title: 'Force layout', className: 'fa fa-snowflake-o', "aria-hidden": 'true' })),
                        React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', onClick: this.props.onExampleClick },
                            React.createElement("span", { title: 'Example button' }, "Exapmle button")))))));
    };
    return Toolbar;
}(React.Component));
exports.Toolbar = Toolbar;
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var model = workspace.getModel();
    var diagram = common_1.tryLoadLayoutFromLocalStorage();
    model.importLayout({
        dataProvider: new index_1.DemoDataProvider(CLASSES, LINK_TYPES, ELEMENTS, LINKS),
        diagram: diagram,
        validateLinks: true,
    });
}
var props = {
    ref: onWorkspaceMounted,
    onSaveDiagram: function (workspace) {
        var diagram = workspace.getModel().exportLayout();
        window.location.hash = common_1.saveLayoutToLocalStorage(diagram);
        window.location.reload();
    },
    toolbar: React.createElement(Toolbar, { onExampleClick: function () { alert('Example button have been pressed!'); } }),
};
common_1.onPageLoad(function (container) { return ReactDOM.render(React.createElement(index_1.Workspace, props), container); });
